<template>
  <div>
    <div class="flex-x-center">
      <div class="profile-contents">
        <div class="project-content" v-html="process.content"></div>
      </div>
    </div>

    <div class="flex-x-center agree-sign-next">
      <el-checkbox v-model="kscnModel.check" class="agree-pro" :disabled="kscnModel.disable === 0">{{ process.tips }}
      </el-checkbox>
      <el-input style="width: 200px" class="sign-name" placeholder="请签名" v-model="sign_name"
        :disabled="kscnModel.disable === 0">
      </el-input>
      <button v-show="process.enable == 1" class="next-step" @click="nextTwoActive()">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { erroralert, successalert } from "@/utils/alert";
export default {
  data() {
    return {
      kscnModel: {
        check: false,
        disable: 1,
      },

      sign_name: "",
    };
  },
  mounted() {
    if (this.$parent.projectDetail.current_step > this.process_index) {
      this.kscnModel.check = true;
      this.kscnModel.disable = 0;
      this.sign_name = this.$parent.userCertInfo.truename;
    }
  },
  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  methods: {
    //考生承诺
    nextTwoActive() {
      console.log(this.sign_name);

      console.log("2222", this.$parent.userCertInfo);
      if (
        this.kscnModel.check !== true ||
        this.sign_name !== this.$parent.userCertInfo.truename
      ) {
        erroralert(this.process.tips);
        return;
      }
      // projectDetail[2].Fields[1].options
      console.log(this.process.options);
      this.$parent.next();
    },
  },
  computed: {
    ...mapState(useMainStore, {
      projectDetail: "getProjectDetail",
    }),
  },
};
</script>

<style scoped>
.profile-contents {
  font-size: 15px;
  letter-spacing: 1px;
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 5px;
  box-sizing: border-box;
}
</style>
